import axios from 'axios';
import { fetchF24List } from '~/api/bookkeeping/taxes';
import { backendApiGateway } from '~/client/backend';
import { captureException } from '~/hooks/useExceptionLogger';
import { Company } from '~/types/company';
import { F24ValidBank } from '~/types/f24';
import { F24, F24Source } from '~/types/taxes';
export const uploadF24Contabile = async (file: File, companyId: Company['id']) => {
  const {
    data: { url, filename },
  } = await backendApiGateway.post<{ url: string; filename: string }>(`/api/v1/f24/${companyId}/upload-contabile`, {
    contentType: file.type,
  });

  await axios.put(url, file, { headers: { 'Content-Type': file.type } });
  return filename;
};

export const getF24PdfDownloadUrl = async (f24Id: F24['id']) => {
  const {
    data: { url },
  } = await backendApiGateway.get<{ url: string }>(`/api/v1/f24/${f24Id}/download`);

  return url;
};

export const fetchF24ValidBanks = async (): Promise<F24ValidBank[]> => {
  const { data } = await backendApiGateway.get<{ data: F24ValidBank[] }>('/api/v1/f24/valid-banks');
  return data.data;
};

export const fetchF24SddCutoff = async (paymentDate: string): Promise<{ beforeCutoff: boolean }> => {
  const { data } = await backendApiGateway.get<{ before_cutoff: boolean }>('/api/v1/f24/sdd-cutoff', {
    params: { payment_date: paymentDate },
  });
  return { beforeCutoff: data.before_cutoff };
};

export const hasNoUploadedF24 = async (companyId: string) => {
  try {
    const data = await fetchF24List(
      companyId,
      {
        source: [F24Source.UPLOAD],
      },
      { size: 1 },
    );
    return data.length === 0;
  } catch (err) {
    captureException(err, {
      extra: {
        help_text: 'error checking if company has uploaded F24 payments',
      },
    });
    return false;
  }
};
